var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenGraph = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53865 16.6642L9.87815 18L16.9041 11.4108L21.3016 15.4914L31.6637 5.47327L30.2989 4.15381L21.268 12.8769L16.8957 8.81263L8.53865 16.6642ZM4.98096 31.8462H29.8769V25.0282H6.78117V4.15389H4.98096V31.8462ZM28.0846 30.0958H6.78899V26.7862H28.0846V30.0958Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenGraph.e409ccdbbaff190b1b25099b5f9750dc.svg";